import { useEffect, useState } from 'react';

/**
 * Devuelve un timestamp (ms) que se actualiza cada `intervalMs`. Pensado
 * para renderear "elapsed live" en sesiones en curso (Fase 42).
 *
 * `enabled=false` corta el interval — para evitar timers innecesarios en
 * páginas donde no hay sesiones live visibles.
 */
export function useLiveClock(intervalMs = 1000, enabled = true): number {
  const [now, setNow] = useState<number>(() => Date.now());
  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs, enabled]);
  return now;
}
